// extracted by mini-css-extract-plugin
module.exports = {"page-layout":"style_page-layout__cTum3","main-layout":"style_main-layout__Pgppc","content":"style_content__9pZHh"};